import { ReactNode } from "react";
import { Box } from "@mui/material";

interface IInfoBoxProps {
    icon: ReactNode;
    children?: ReactNode;
}

export const InfoBox = ({ icon, children }: IInfoBoxProps): JSX.Element => {
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "flex-start",
                borderRadius: 1,

                background: "var(--mui-palette-gray-50)",
                gap: 1,
                padding: 2,
            }}
        >
            {icon}
            {children}
        </Box>
    );
};
